import { ButtonBaseProps } from "./ButtonBaseProps";

export function ButtonBase(props: ButtonBaseProps) {
  const { href, type = "button", children, target, ref, ...attrs } = props;
  const defaultRel = target === "_blank" ? "noopener" : undefined;

  if (href) {
    return (
      <a rel={defaultRel} {...attrs} ref={ref} href={href} target={target}>
        {children}
      </a>
    );
  }

  return (
    <button {...attrs} type={type} ref={ref}>
      {children}
    </button>
  );
}
